import { getInlineValue } from './common.js';

var transformLogicalInlinePropertyWithShorthand = function transformLogicalInlinePropertyWithShorthand(properties) {
  return function (value) {
    var _getInlineValue = getInlineValue(value),
        baseValue = _getInlineValue.baseValue,
        startValue = _getInlineValue.startValue,
        endValue = _getInlineValue.endValue;

    var base;
    var ltr;
    var rtl;

    if (baseValue) {
      base = "\n                ".concat(properties.ltrStartProperty, ": ").concat(baseValue, ";\n                ").concat(properties.ltrEndProperty, ": ").concat(baseValue, ";\n            ");
    }

    if (startValue && endValue) {
      ltr = "\n                ".concat(properties.ltrStartProperty, ": ").concat(startValue, ";\n                ").concat(properties.ltrEndProperty, ": ").concat(endValue, ";\n            ");
    }

    if (startValue && endValue) {
      rtl = "\n                ".concat(properties.ltrEndProperty, ": ").concat(startValue, ";\n                ").concat(properties.ltrStartProperty, ": ").concat(endValue, ";\n            ");
    }

    return {
      base: base,
      ltr: ltr,
      rtl: rtl
    };
  };
};

export { transformLogicalInlinePropertyWithShorthand };
